import Spinner from "assets/icons/spinner.svg"
import { rotate } from "shared/styles/keyframes"
import styled from "styled-components"

const LoaderWrapper = styled.div<{ $color?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  svg {
    animation: ${rotate} 1.2s infinite linear;
    width: 20%;
    max-width: 200px;
    max-height: 60%;

    circle {
      stroke: ${(props) => props.$color ?? "#333333"};
    }
  }
`

export type ResponsiveLoaderProps = {
  color?: string
}

const ResponsiveLoader = ({ color }: ResponsiveLoaderProps) => (
  <LoaderWrapper $color={color}>
    <Spinner />
  </LoaderWrapper>
)

export default ResponsiveLoader
